<div edsRow>
  <div edsCol>
    <ng-container *ngFor="let button of buttonsCollection">
      <a
        [href]="button.href"
        [target]="button.target"
        [ngClass]="button.external ? 'external-link' : ''"
        [edsButton]="button.buttonStyle"
        >{{ button.ctaText }}</a
      >
    </ng-container>
  </div>
</div>
